export default __webpack_public_path__ + "173d458cd6c537e26e3fc8203d8a1e12.png";